import { Tooltip } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ClockPlus } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { TaskTypeStyles } from './styles'

export const ExtensionGrantTaskIcon: React.FC = () => {
    return (
        <Tooltip
            title={<FormattedMessage id="task_type_extension_grant" defaultMessage="Extension request" />}
            placement="top"
        >
            <C1Icon icon={ClockPlus} sx={TaskTypeStyles.extensionGrantIcon} />
        </Tooltip>
    )
}
